<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0"></p>
    </div>
    <div class="col-md-6">
      <p class="pull-right mb-0">Developed with <i class="fa fa-heart font-secondary"></i></p>
    </div>
  </div>
</div>